import { useQuery } from '@tanstack/react-query';
import type { DueState, MonitoringListItem } from '@tww/shared';
import { CONDITION_LABELS, IMPROVEMENT_LABELS, MONITORING_KIND_LABELS, MONITORING_STATUS_LABELS, WILDLIFE_LABELS } from '@tww/shared';
import { api } from '../../api/client';
import { StatusPill } from '../../ui/basics';

export interface PickUser { id: number; display_name: string; initials: string | null }
export function useUsersPick() {
  return useQuery({ queryKey: ['users', 'pick'], queryFn: () => api.get<{ items: PickUser[] }>('/users/pick').then((r) => r.items), staleTime: 60_000 });
}

/** Fälligkeit als Pille: überfällig rot, fällig blau, kommend grau, erledigt grün */
export function DuePill({ due, status }: { due: DueState; status: MonitoringListItem['status'] }) {
  if (status === 'done') return <StatusPill code="bestaetigt" label="erledigt" />;
  if (status === 'skipped') return <StatusPill code="muted" label="entfallen" />;
  const cls = due.kind === 'overdue' ? 'offen' : due.kind === 'due' ? 'abstimmung' : 'muted';
  return <StatusPill code={`${cls} mon-pill`} label={due.label} />;
}
export function MonitoringStatusPill({ status }: { status: MonitoringListItem['status'] }) {
  const cls = status === 'done' ? 'bestaetigt' : status === 'in_progress' ? 'zugesagt' : status === 'skipped' ? 'muted' : 'abstimmung';
  return <StatusPill code={cls} label={MONITORING_STATUS_LABELS[status]} />;
}
/** "1. Monitoring", "2. Monitoring (zusätzlich)", "Nachfrage" */
export const monitoringTitle = (m: { number: number; kind: MonitoringListItem['kind'] }) => (m.kind === 'inquiry' ? 'Nachfrage beim Förster' : `${m.number}. Monitoring${m.kind === 'additional' ? ` (${MONITORING_KIND_LABELS.additional})` : ''}`);
export const conditionLabel = (c: MonitoringListItem['condition']) => (c ? CONDITION_LABELS[c] : '–');
export const wildlifeLabel = (w: MonitoringListItem['last'] extends infer T ? (T extends { wildlife_intact: infer W } ? W : never) : never) => (w ? WILDLIFE_LABELS[w as keyof typeof WILDLIFE_LABELS] : '–');
export const improvementLabel = (i: keyof typeof IMPROVEMENT_LABELS | null | undefined) => (i ? IMPROVEMENT_LABELS[i] : '–');
export const YEAR_OPTIONS = (center: number) => Array.from({ length: 7 }, (_, i) => center - 2 + i);
